import React from 'react';
import { TouchableOpacity } from 'react-native';
import { IconButton, Surface } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import LocationTag from '@src/components/LocationTag';
import useLike from '@src/components/PostCard/useLike';
import Row from '@src/components/Row';
import Separator from '@src/components/Separator';
import { Body1 } from '@src/components/Typography';
import UserTag from '@src/components/UserTag';
import { activeOpacity } from '@src/configuration/constants';
import { Post } from '@src/types';

type Props = {
  item: Post;
};

const Container = styled(Surface)`
  overflow: hidden;
  border-color: ${({ theme }) => theme.colors.placeholder};
  border-radius: ${({ theme }) => theme.roundness}px;
  width: 315px;
  background-color: ${({ theme }) => theme.colors.background};
`;

const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
  align-items: center;
`;

const Cover = styled(Image).attrs({ resizeMode: 'cover' })`
  width: 100%;
  height: 196px;
  background-color: ${({ theme }) => theme.colors.placeholder};
`;

const Button = styled(IconButton).attrs(({ theme }) => ({
  color: theme.colors.placeholder,
}))``;

const Component: React.FC<Props> = ({ item }) => {
  const navigation = useNavigation();
  const { user, date, place, medias, commentsCount } = item;

  const { handleLike, liked, likesCount } = useLike(
    item.id,
    item.liked,
    item.likesCount
  );

  const handlePostPress = React.useCallback(
    () => navigation.navigate('Post', { id: item?.id }),
    [item, navigation]
  );

  const source = React.useMemo(() => {
    const firstMedia = medias?.[0];
    if (firstMedia) {
      if (firstMedia.type === 'PHOTO') {
        return firstMedia.source;
      } else if (firstMedia.type === 'VIDEO') {
        return firstMedia.thumbnail;
      }
    }
    return undefined;
  }, [medias]);
  return (
    <Container>
      <Separator />
      <Header>
        <UserTag maxTextLength={12} date={date} user={user} />
        <LocationTag
          maxTextLength={12}
          barStyle="light-content"
          place={place}
        />
      </Header>
      <TouchableOpacity onPress={handlePostPress} activeOpacity={activeOpacity}>
        <Cover
          // @ts-ignore
          source={source}
        />
      </TouchableOpacity>
      <Row>
        <Row>
          {liked ? (
            <IconButton color="#D0021B" icon="heart-o" onPress={handleLike} />
          ) : (
            <Button icon="heart-o" onPress={handleLike} />
          )}
          <Body1>{likesCount}</Body1>
        </Row>
        <Row>
          <Button icon="comment-alt-o" onPress={handlePostPress} />
          <Body1>{commentsCount}</Body1>
        </Row>
      </Row>
    </Container>
  );
};

Component.displayName = 'TinyPostCard';

export default React.memo(Component);
